function accordionAny(container, collapsible) {

    var button  = container.find('._js-accordion-button'),
        accordionBody = container.find('.js-accordion__body');


    button.on('click', function(){
        var accordion = $(this).parents('.js-accordion');

        if ( !accordion.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.js-accordion').removeClass('_expanded');
                accordionBody.stop().slideUp(300);
            }
            accordion.addClass('_expanded');
            accordion.find('.js-accordion__body').slideDown(300);
        }
        else {
            accordion.removeClass('_expanded');
            accordion.find('.js-accordion__body').stop().slideUp(300);
        }
    });
}